<template>
  <v-row>
    <v-col cols="12" class="px-0">
      <v-toolbar color="transparent" flat height="55">
        <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Resumen</v-toolbar-title>
      </v-toolbar>
    </v-col>

    <!-- cash entry -->
    <v-col cols="4">
      <metric-kpi metric="total_payments_received" interval="monthly" comparative="this_v_last_mtd" />
    </v-col>
    <v-col cols="4">
      <metric-kpi metric="recurrent_payments" interval="monthly" comparative="this_v_last_mtd" />
    </v-col>
    <v-col cols="4">
      <metric-kpi metric="unreconciled_transfers" interval="monthly" comparative="this_v_last_mtd" />
    </v-col>
    <!-- end cash entry -->

    <!-- when and how it arrived -->
    <v-col cols="6">
      <metric-graph metric="total_payments" interval="daily" :start="dailyStart" :end="dailyEnd" />
    </v-col>
    <v-col cols="6">
      <metric-graph metric="transactions_received_by_gateway" />
    </v-col>
    <!-- end when and how it arrived -->

    <!-- what hasn't arrived yet -->
    <v-col cols="4">
      <metric-kpi metric="total_receivables_current_due" interval="monthly" />
    </v-col>
    <v-col cols="4">
      <metric-kpi metric="total_receivables_overdue" interval="monthly" />
    </v-col>
    <v-col cols="4">
      <metric-kpi metric="total_receivables" interval="monthly" />
    </v-col>
    <v-col cols="12" class="pt-0">
      <v-btn color="primary" text :ripple="false" :to="{ name: 'Receivables' }">Ver cuentas por cobrar<v-icon class="mt-1" right small>mdi-arrow-right</v-icon></v-btn>
    </v-col>
    <!-- end what hasn't arrived yet -->

  </v-row>
</template>
<script>
import moment from 'moment'

import MetricGraph from '@/components/reports/MetricGraph'
import MetricKpi from '@/components/reports/MetricKpi'

export default {
  components: {
    MetricGraph,
    MetricKpi
  },
  data: () => ({
    // "when did it arrive" is an intra-month question: 30 day daily series.
    // the end of the API time serie is exclusive, hence tomorrow
    dailyStart: moment().subtract(29, 'days').format('YYYY-MM-DD'),
    dailyEnd: moment().add(1, 'days').format('YYYY-MM-DD')
  })
}
</script>
